import { useEffect, useRef, useState } from "react";

const POSITION_OPTIONS: PositionOptions = {
  timeout: 5000,
  maximumAge: 5 * 60 * 1000,
};

export const useUserLocation = (
  enabled: boolean,
): google.maps.LatLngLiteral | null => {
  const [location, setLocation] = useState<google.maps.LatLngLiteral | null>(
    null,
  );
  const requested = useRef(false);

  useEffect(() => {
    if (!enabled || requested.current || !navigator.geolocation) return;
    requested.current = true;

    let active = true;
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        if (active) {
          setLocation({ lat: coords.latitude, lng: coords.longitude });
        }
      },
      () => {},
      POSITION_OPTIONS,
    );

    return () => {
      active = false;
    };
  }, [enabled]);

  return location;
};
